var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isUsuarioExterno && _vm.exibeObs
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("app-header-dados-processo", {
                attrs: {
                  showBotaoOpcoesHeader: false,
                  processo: _vm.processo,
                  isCCR: _vm.isCCR,
                  dadosCadastros: _vm.dadosCadastros
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-collapse", attrs: { shadow: "hover" } },
        [
          _c("app-divider", {
            attrs: { label: "Dados do Cálculo: ", addMarginTop: false }
          }),
          _vm.dadosVtn
            ? _c(
                "div",
                { staticClass: "centerDados" },
                [
                  _c(
                    "el-col",
                    { staticClass: "flex", attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Somatório dos Fatores de Redução:",
                          content: _vm.getValor(
                            _vm.dadosVtn,
                            "somatorioDosConficientesFormatado"
                          )
                            ? _vm.getValor(
                                _vm.dadosVtn,
                                "somatorioDosConficientesFormatado"
                              )
                            : "-",
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Valor do VTN Para Área em Uso:",
                          content: _vm
                            .getValorNumerico(
                              _vm.dadosVtn,
                              "municipio, valorReferencia"
                            )
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL"
                            }),
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Valor do VTN Para Área de Reserva Legal:",
                          content: _vm
                            .getValorNumerico(
                              _vm.dadosVtn,
                              "vtnAreaReservaLegal"
                            )
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL"
                            }),
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Valor Total do Imóvel:",
                          content: _vm.dadosVtn.valorFinalImovelFormatado,
                          contentAlignRight: false
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "flex", attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Porcentagem Máxima Para Redução (%):",
                          content: _vm.getValor(
                            _vm.dadosVtn,
                            "porcentagemMaximaReducaoFormatada"
                          ),
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "VTN: Para Área em Uso(R$/ha):",
                          content: _vm
                            .getValorNumerico(_vm.dadosVtn, "vtntAreaUso")
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL"
                            }),
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "VTN: Para Área de Reserva Legal(R$/ha)",
                          content: _vm
                            .getValorNumerico(_vm.dadosVtn, "vtntReservaLegal")
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL"
                            }),
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Valor Total do Imóvel a Vista (R$):",
                          content: _vm.dadosVtn.valorAVistaFormatado,
                          contentAlignRight: false
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "flex", attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Porcentagem Aplicável Para Redução:",
                          content: _vm.getValor(
                            _vm.dadosVtn,
                            "percentualAplicadoFormatado"
                          ),
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Valor do Imóvel em Relação a Área em Uso:",
                          content: _vm
                            .getValorNumerico(_vm.dadosVtn, "vtnAreaUso")
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL"
                            }),
                          contentAlignRight: false
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label:
                            "Valor do Imóvel em Relação a Área de Reserva Legal:",
                          content: _vm
                            .getValorNumerico(_vm.dadosVtn, "vtnReservaLegal")
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL"
                            }),
                          contentAlignRight: false
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      !_vm.isGerenciar && _vm.escolheuExterno && !_vm.isCriado
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("div", { staticClass: "cardHeader" }, [
                _c("b", [_vm._v("Formas de pagamento:")])
              ]),
              _c("div", { attrs: { id: "line" } }),
              _c(
                "div",
                { staticClass: "centerRadio" },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "radio-group",
                      attrs: {
                        disabled: _vm.isVisualizar,
                        name: "Cônjuge possui certidão?"
                      },
                      model: {
                        value: _vm.dadosVtn.formaPagamento,
                        callback: function($$v) {
                          _vm.$set(_vm.dadosVtn, "formaPagamento", $$v)
                        },
                        expression: "dadosVtn.formaPagamento"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: "PARCELADO" } },
                        [_vm._v("Pagamento parcelado")]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: "A_VISTA" } },
                        [_vm._v("Pagamento à vista")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.dadosVtn.formaPagamento === "PARCELADO"
                ? _c("div", { staticClass: "flexStart margin10" }, [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("span", [_vm._v("Período de carência (PC):")]),
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.isVisualizar,
                              placeholder: "Selecione",
                              "value-key": "id"
                            },
                            on: { change: _vm.changeCarencia },
                            model: {
                              value: _vm.dadosVtn.carencia,
                              callback: function($$v) {
                                _vm.$set(_vm.dadosVtn, "carencia", $$v)
                              },
                              expression: "dadosVtn.carencia"
                            }
                          },
                          _vm._l(_vm.carencias, function(carencia) {
                            return _c("el-option", {
                              key: carencia.id,
                              attrs: {
                                label: carencia.value,
                                value: carencia.id
                              },
                              on: {
                                change: function($event) {
                                  return _vm.calcular(false)
                                }
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("span", [_vm._v("Nº de parcelas anuais (n):")]),
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.isVisualizar,
                              placeholder: "Selecione",
                              "value-key": "id"
                            },
                            on: {
                              change: function($event) {
                                return _vm.calcular(false)
                              }
                            },
                            model: {
                              value: _vm.dadosVtn.qntdParcelas,
                              callback: function($$v) {
                                _vm.$set(_vm.dadosVtn, "qntdParcelas", $$v)
                              },
                              expression: "dadosVtn.qntdParcelas"
                            }
                          },
                          _vm._l(_vm.parcelasComputed, function(parcela) {
                            return _c("el-option", {
                              key: parcela.id,
                              attrs: { label: parcela.value, value: parcela.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "flex margin10" },
                [
                  _c(
                    "el-col",
                    { staticClass: "flex", attrs: { span: 9 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Resumo",
                          content: "",
                          contentAlignRight: false
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "flex", attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Valor(R$)",
                          content: "",
                          contentAlignRight: false
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "flex", attrs: { span: 7 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Data vencimento",
                          content: "",
                          contentAlignRight: false
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.parcelasPagar, function(parcela) {
                return _vm.parcelasPagar
                  ? _c(
                      "div",
                      { staticClass: "flex margin10" },
                      [
                        _c(
                          "el-col",
                          { staticClass: "flex", attrs: { span: 9 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: _vm.getLabel(parcela),
                                content: "",
                                contentAlignRight: false
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { staticClass: "flex", attrs: { span: 8 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: parcela.valorFormatado,
                                content: "",
                                contentAlignRight: false
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { staticClass: "flex", attrs: { span: 7 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: parcela.dataVencimentoFormatada,
                                content: "",
                                contentAlignRight: false
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              })
            ],
            2
          )
        : _vm._e(),
      !_vm.isVisualizar
        ? _c("app-buttons-cadastro", {
            attrs: {
              showButtonSalvar: false,
              showButtonCancelar: !_vm.isResumo,
              showButtonFinalizar: true,
              isUltimoPasso: true,
              isPrimeiroPasso: !_vm.isResumo,
              isIntroPasso: false
            },
            on: {
              cancelar: _vm.cancelar,
              finalizar: _vm.finalizar,
              voltar: _vm.cancelar
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f052789c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f052789c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/VisualizarVtnRR.vue
// module id = null
// module chunks = 